export default "__VITE_ASSET__Bqa6tkve__$_?format=webp__"